import { CachedMasterDataService } from '../../api/cached-master-data-service';
import { MetricGroupId } from '../../graphql/generated/graphql-sdk';
import { MetricStore } from '../metric-store';
import {
  getPbsByDimensionServiceForCohortBackendMetrics,
  getPbsByDimensionServiceForEmployeeCohortBackendMetrics,
  getPbsByDimensionServiceForRegularBackendMetrics,
} from './getPbsByDimensionServiceForBackendMetrics';
import {
  getPbsOverTimeServiceForCohortBackendMetric,
  getPbsOverTimeServiceForEmployeeCohortBackendMetric,
  getPbsOverTimeServiceForRegularBackendMetric,
} from './getPbsOverTimeServiceForBackendMetrics';
import { getPbsSegmentationServiceForMetricGroup } from './getPbsSegmentationServiceForBackendMetrics';

export const getMetricOverTimeService = (
  metricGroupId: MetricGroupId,
  metricStore: MetricStore,
  cachedMasterDataService: CachedMasterDataService
) => {
  return metricStore.isMetricGroupRegular(metricGroupId)
    ? getPbsOverTimeServiceForRegularBackendMetric(
        metricGroupId,
        cachedMasterDataService
      )
    : metricStore.isMetricGroupCohort(metricGroupId)
      ? getPbsOverTimeServiceForCohortBackendMetric(
          metricGroupId,
          cachedMasterDataService
        )
      : getPbsOverTimeServiceForEmployeeCohortBackendMetric(
          metricGroupId,
          cachedMasterDataService
        );
};

export const getMetricByDimensionService = (
  metricGroupId: MetricGroupId,
  metricStore: MetricStore,
  cachedMasterDataService: CachedMasterDataService
) => {
  return metricStore.isMetricGroupRegular(metricGroupId)
    ? getPbsByDimensionServiceForRegularBackendMetrics(
        metricGroupId,
        cachedMasterDataService
      )
    : metricStore.isMetricGroupCohort(metricGroupId)
      ? getPbsByDimensionServiceForCohortBackendMetrics(
          metricGroupId,
          cachedMasterDataService
        )
      : getPbsByDimensionServiceForEmployeeCohortBackendMetrics(
          metricGroupId,
          cachedMasterDataService
        );
};

// Unlike the services above, segmentation picks the backend per metric, so a
// group mixing metric types is supported.
export const getMetricSegmentationService = (
  metricGroupId: MetricGroupId,
  cachedMasterDataService: CachedMasterDataService
) =>
  getPbsSegmentationServiceForMetricGroup(
    metricGroupId,
    cachedMasterDataService
  );
